<template>
  <div class="page">
    <Header
      :title="title"
      :hideStoreName="hideStoreName"
      :storeNameFull="storeNameFull"
      :storeSelectable="storeSelectable"
      :onSelect="onStoreSelect"
      :onHome="onHome"
      :showBack="showBack"
      :noIcon="noIcon"
      @back="onBack"
    >
      <slot name="header-center" slot="center" />
      <!-- @slot ヘッダーに表示するボタンなど -->
      <slot name="header" />
    </Header>
    <slot name="main">
      <main :style="gridStyle">
        <slot />
      </main>
    </slot>
    <LoadingIndicator v-if="loading" />
  </div>
</template>

<script>
import Header from '@/components/organisms/Header'
import LoadingIndicator from '@/components/molecules/LoadingIndicator'
import Dialog from '@/components/molecules/ModalDialog'

/**
 * 画面テンプレート
 */
export default {
  name: 'SimplePage',
  components: {
    Header,
    LoadingIndicator,
  },
  props: {
    /** タイトル */
    title: String,
    /** 戻るボタンの表示 */
    showBack: Boolean,
    /** ボタンの非表示 */
    noIcon: Boolean,
    /** 店舗名を非表示にする */
    hideStoreName: Boolean,
    /** 店舗名を全て表示するかどうか */
    storeNameFull: Boolean,
    /** 店舗切り替え可否 */
    storeSelectable: Boolean,
    /** 店舗切り替えのハンドラ */
    onStoreSelect: Function,
    /** ホームボタンのハンドラ */
    onHome: Function,
    /** ロード中の表示 */
    loading: Boolean,
    /** グリッドレイアウトのスタイルオプション */
    gridStyle: [String, Object],
  },
  created() {
    window.addEventListener('click', this.confirmDialog)
  },
  beforeDestroy() {
    window.removeEventListener('click', this.confirmDialog)
  },
  methods: {
    onBack() {
      /** @event back 戻るボタンのクリック */
      this.$emit('back')
    },
    async confirmDialog(e) {
      if (!this.$store.state.app.editing) return

      const target = e.target.closest('a')
      const isHash = target && target.getAttribute('href') === '#'
      if (!target || isHash) return
      e.preventDefault()
      e.stopPropagation()

      if (await Dialog.confirmLeaveSetting(this.$route.path)) {
        location.assign(e.target.href)
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.page {
  display: flex;
  flex-direction: column;
  height: 100%;

  > main {
    align-content: flex-start;
    display: grid;
    flex: 1;
    grid-gap: 16px;
    overflow: auto;
  }

  .app & {
    height: 100vh;
  }
}
</style>
